module.exports = __webpack_public_path__ + "img/panelView_baoSteel_2_3.2f149077.png";